module.exports = __webpack_public_path__ + "img/carshina22_27.0a83095a.jpg";